import constants from "./constants";
import { createReducer, updateObject } from "../../utils/reduxHelper";

const initialState = {
  currentUser: null,
};

const setUserData = (state, action) =>
  updateObject(state, { currentUser: action.payload });

const logout = state => updateObject(state, { currentUser: null });

const handlers = {};
handlers[constants.USER_SET_DATA] = setUserData;
handlers[constants.USER_LOGOUT] = logout;

const userReducer = createReducer(initialState, handlers);

export default userReducer;



// WEBPACK FOOTER //
// ./src/modules/user/reducer.js